import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/js/rem.js'
import './assets/css/reset.css'
// import login from './assets/js/login.js'
import expoId from './api/common.js'
import vueAwesomeSwiper  from 'vue-awesome-swiper';
import './assets/css/swiper.css';
import axios from 'axios'

import Modal from "./lib/index.js";
Vue.use(Modal)

Vue.use(vueAwesomeSwiper)

Vue.prototype.$expoId = expoId;
Vue.prototype.$axios = axios



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
